<template>
  <v-container  class="my-0 py-1" fluid>
    <v-row>
      <v-col class="col-3">
        <v-text-field
          placeholder="Buscar proyecto..."
          v-model="search"
          hide-details
          append-icon="search"
        ></v-text-field>
      </v-col>
      <v-col class="text-right">
        <v-btn color="primary" @click="selected = {}; createUpdate = true">Nuevo Proyecto</v-btn>
      </v-col>
    </v-row>
    <v-data-table :headers="headers" :items="_proyectos" :search="search" :items-per-page="5">
      <template v-slot:item.name="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <a href="#" @click.stop="selected = item; showImage()" v-on="on">[{{ item.name }}]</a><small v-if="!item.image"> - [SIN FOTO]</small>
          </template>
          <span>Ver imagen: {{ item.name.toUpperCase() }}</span>
        </v-tooltip>
      </template>
      <template v-slot:item.enabled="{ item }">
        <v-switch v-model="item.enabled" @change="updateEnabled(item)"></v-switch>
      </template>
      <template v-slot:item.canlogin="{ item }">
        <v-switch v-model="item.canlogin" @change="updateCanLogin(item)"></v-switch>
      </template>
      <!-- <template v-slot:item.image="{ item }">
        <v-img
          v-on="on"
          class="ma-3"
          :src="$getImage(item.image)"
          width="70"
          @click="selected = item; showImage()"
        ></v-img>
      </template> -->
      <template v-slot:item.acciones="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" color="primary" small text @click="selected = item; uploadDlg = true">
              <i class="fa fa-image"></i>
            </v-btn>
          </template>
          <span>{{ !item.image ? 'Asignar nueva' : 'Cambiar' }} imagen</span>
        </v-tooltip>

        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              v-on="on"
              color="warning"
              small
              text
              @click="selected = item; createUpdate = true"
            >
              <i class="fa fa-pencil"></i>
            </v-btn>
          </template>
          <span>Editar</span>
        </v-tooltip>

        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" color="error" small text @click="deleteProject(item)">
              <i class="fa fa-trash"></i>
            </v-btn>
          </template>
          <span>Eliminar</span>
        </v-tooltip>
      </template>
    </v-data-table>

    <v-dialog width="500" v-model="createUpdate">
      <v-card>
        <v-card-title>{{ selected.id ? 'Editar' : 'Crear' }} proyecto</v-card-title>
        <form @submit.prevent="createOrUpdate">
          <v-card-text>

            <v-text-field label="Nit" outlined required v-model="selected.nit"></v-text-field>
            <v-text-field label="Nombre" outlined required v-model="selected.name" hide-details></v-text-field>
            <v-menu
              ref="menu"
              v-model="menu"
              :close-on-content-click="false"
              :return-value.sync="selected.start_date"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="selected.start_date"
                  label="Fecha de inicio"
                  readonly
                  outlined
                  required
                  v-on="on"
                  hide-details
                ></v-text-field>
              </template>
              <v-date-picker v-model="selected.start_date" no-title scrollable>
                <div class="flex-grow-1"></div>
                <v-btn text color="primary" @click="menu = false">Cancel</v-btn>
                <v-btn text color="primary" @click="$refs.menu.save(selected.start_date)">OK</v-btn>
              </v-date-picker>
            </v-menu>
          </v-card-text>
          <v-card-actions>
            <div class="flex-grow-1"></div>
            <v-btn type="submit" color="success">Guardar {{ selected.id ? 'Cambios' : '' }}</v-btn>
          </v-card-actions>
        </form>
      </v-card>
    </v-dialog>

    <v-dialog width="300" v-model="uploadDlg">
      <v-card>
        <v-card-title>Cambiar imagen</v-card-title>
        <form @submit.prevent="changeAvatar(item)">
          <v-card-text>
            <v-img src></v-img>
            <v-file-input v-model="file" label="Imagen" filled hide-details required></v-file-input>
          </v-card-text>
          <v-card-actions>
            <div class="flex-grow-1"></div>
            <v-btn block color="success" type="submit">Subir</v-btn>
          </v-card-actions>
        </form>
      </v-card>
    </v-dialog>

  </v-container>
</template>

<script>
import Vue from "vue";
import { API } from "../../../globals";
import moment from "moment";
import { apiv1 } from "../../../libs/apiv1";

export default Vue.extend({
  name: "Proyectos",
  data: () => ({
    search: null,
    selected: {},
    createUpdate: false,
    headers: [
      { text: "Nit", value: "nit" },
      { text: "Nombre", value: "name" },
      { text: "Fecha de inicio", value: "start_date" },
      { text: "Habilitado", value: "enabled" },
      { text: "Login", value: "canlogin" },
      // { text: "Imagen", value: "image" },
      {
        text: "Acciones",
        value: "acciones",
        sortable: false,
        align: "center"
      }
    ],
    proyectos: [],
    uploadDlg: false,
    file: null,
    menu: false
  }),
  computed: {
    _proyectos: function() {
      return this.proyectos.map(function(item) {
        item.start_date = moment(item.start_date).format("YYYY-MM-DD");
        return item;
      });
    }
  },
  mounted() {
    this.getProjects();
  },
  methods: {
    getProjects: function() {
      apiv1({
        method: "GET",
        url: `projects`
      }).then(res => (this.proyectos = res.data));
    },
    changeAvatar: function() {
      const fd = new FormData();
      fd.append("imagen", this.file);
      apiv1({
        method: "PUT",
        url: `project/avatar/${this.selected.id}?old=${this.selected.image}`,
        data: fd
      }).then(res => {
        this.getProjects();
        this.uploadDlg = false;
        this.file = null;
        this.selected = {};
        this.$awn.success(res.data);
      });
    },
    createOrUpdate: function() {
      let url = `projects`;
      let method = "POST";

      this.selected.enabled = true;
      this.selected.canlogin = true;


      if (this.selected.id) {
        url = `project/${this.selected.id}`;
        method = "PUT";
      }

      apiv1({
        method: method,
        url: url,
        data: this.selected
      }).then(res => {
        this.getProjects();
        this.selected = {};
        this.createUpdate = false;
        this.$awn.success(res.data);
      });
    },
    deleteProject: function(item) {
      this.$swal({
        title: "Continuar?",
        text: `¿Seguro que desea eliminar el proyecto '${item.name.toUpperCase()}'?`,
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Si, deseo eliminarlo",
        cancelButtonText: "No",
        showCloseButton: true,
        showLoaderOnConfirm: true
      }).then(result => {
        if (result.value) {
          this.$awn.async(
            apiv1({
              method: "DELETE",
              url: `project/${item.id}`
            }),
            res => {
              this.getProjects();
              this.$awn.success(res.data);
            },
            err => this.$awn.alert(err.response.data)
          );
        }
      });
    },
    updateCanLogin: function(item) {
      apiv1({
        method: "PUT",
        url: `project/canlogin/${item.id}`
      }).then(res => {
        this.getProjects();
        this.$awn.success(res.data);
      });
    },
    updateEnabled: function(item) {
      apiv1({
        method: "PUT",
        url: `project/enabled/${item.id}`
      }).then(res => {
        this.getProjects();
        this.$awn.success(res.data);
      });
    },
    showImage() {
      this.$alertify.alert('Imagen proyecto: ' + this.selected.name, `
        <div class="wrapper">
          <img class="icon-img" src="${this.$getImage(this.selected.image)}" />
        </div>`)
      .set({
        closable: false
      })
    }
  }
});
</script>

<style lang="scss">
.wrapper {
  display: flex;
  justify-content: center;
  align-items: center; 

  .icon-img{
    width: 200px;
    align-self: center;
  }
}


</style>